(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('MerchantLookup', MerchantLookup);

  MerchantLookup.$inject = ['$resource', 'API_URI'];

  function MerchantLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/merchants';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
